import { Navigate, Outlet } from 'react-router-dom';
import { hasRoleAtLeast } from '@slims/shared/auth';
import type { UserRole } from '@/lib/utils/tenant';
import { useAuthStore } from '@/stores/auth-store';

/**
 * Client role-gate (replaces the server-component layout guards). Auth is
 * already loaded by ProtectedRoute, so we just check the resolved role.
 */
export function RequireRole({ min }: { min: UserRole }) {
	const role = useAuthStore((s) => s.role);
	if (!role || !hasRoleAtLeast(role, min)) return <Navigate to="/dashboard" replace />;
	return <Outlet />;
}

export function RequireSuperadmin() {
	const role = useAuthStore((s) => s.role);
	if (role !== 'superadmin') return <Navigate to="/dashboard" replace />;
	return <Outlet />;
}
